import "./Services.scss";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Card from "../../../components/Card/Card";
import useAnimation from "../../../hooks/useAnimation";
import getImageUrl from "../../../Utils/Services/img/imgFetch";

const Services = () => {
  const { t } = useTranslation();
  const { animateFadeInWithMove } = useAnimation();

  const initAnimation = () => {
    const section = document.querySelectorAll(".servicesSection");
    animateFadeInWithMove(section, 0.6, section);
  };

  useEffect(() => {
    const timeoutId = setTimeout(initAnimation, 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="servicesSectionDiv" id="services">
      <section className="servicesSection" id="servicesSection">
        <h1>{t("home.services.title")}</h1>
        <p>{t("home.services.intro")}</p>

        <div className="servicesGrid">
          <Card type="secondary">
            <img
              src={getImageUrl("services/balade-nature.jpeg")}
              alt={t("home.services.natureWalksTitle")}
            />
            <h3>{t("home.services.natureWalksTitle")}</h3>
            <p>{t("home.services.natureWalksText")}</p>
          </Card>

          <Card type="secondary">
            <img
              src={getImageUrl("services/construction.JPG")}
              alt={t("home.services.customBuildTitle")}
            />
            <h3>{t("home.services.customBuildTitle")}</h3>
            <p>{t("home.services.customBuildText")}</p>
          </Card>

          <Card type="secondary">
            <img
              src={getImageUrl("services/evenements.JPG")}
              alt={t("home.services.eventsTitle")}
            />
            <h3>{t("home.services.eventsTitle")}</h3>
            <p>{t("home.services.eventsText")}</p>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Services;
